<style scoped>

</style>
<template>
  <span>{{ name }}</span>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters('async', ['teams_hash']),
      name() {
        if (!this.id) return '未设置';
        const team = this.teams_hash[this.id];
        return team ? team.name : '未找到';
      }
    },
  }
</script>
